import React from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './AddIconButton.scss';

export class AddIconButton extends React.PureComponent {
  render() {
    return (
      <IconButton
        {...this.props}
        className={'add-icon-button ' + (this.props.className ? this.props.className : '')}
        size="large">
        <AddIcon />
      </IconButton>
    );
  }
}

export class ExpandIconButton extends React.PureComponent {
  render() {
    return <ExpandMoreIcon color="primary" />;
  }
}
